export class JobTemplate {
  id!: string;
  name!: string;
}
